// extracted by mini-css-extract-plugin
export var equalColumn = "_gv-0";